export default class Usuario {

    constructor(nome, sobrenome, email, telefone, dtNascimento, estado, cidade, statusIn, preCadastro, _id, password) {
        this.nome = nome;
        this.sobrenome = sobrenome;
        this.email = email;
        this.telefone = telefone != undefined && telefone.length == 8 ? telefone.replace(/^(\d{4})(\d)/, "$1-$2")
            : telefone != undefined && telefone.length == 11 ? telefone.replace(/^(\d{2})(\d{5})(\d)/, "($1) $2-$3")
                : telefone
        this.dtNascimento = dtNascimento != undefined ? dtNascimento.replace(/^(\d{2})(\d{2})(\d)/, "$1/$2/$3")
                            : dtNascimento;
        this.estado = estado;
        this.plano;
        this.cidade = cidade;
        this.statusIn = statusIn;
        this.preCadastro = preCadastro;
        this._id = _id;

    }

}





// WEBPACK FOOTER //
// ./src/domain/conta/usuario/Usuario.js